/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Progress_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Audio rendering progress" |
*
* @param {Render_Audio_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_progress_aria_label = /** @type {((inputs?: Render_Audio_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression du rendu audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortschritt der Audiowiedergabe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progresso del rendering audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход обработки звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de la representación de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频渲染进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオレンダリングの進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रेंडरिंग की प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso da renderização de áudio")
	return /** @type {LocalizedString} */ ("Audio rendering progress")
});